<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="queryParam.name" class="mb10"
                      style="width: 240px"
                      placeholder="请输入名称"></el-input>
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button class="ml10 mb10" type="primary" @click="handleAddCode">新增公式</el-button>
    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border>
      <el-table-column
          prop="name"
          align="center"
          label="名称"
      />
      <el-table-column
          prop="formula"
          align="center"
          label="公式"
      >
        <template slot-scope="scope">
          {{scope.row.result}}={{scope.row.formula}}
        </template>
      </el-table-column>
      <el-table-column
          prop="intro"
          align="center"
          label="描述"
      />
      <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
      />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="del(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" :rules="rules">
        <el-form-item label="公式名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="运算符号">
          <el-tag
              :key="tag"
              style="cursor: pointer"
              size="medium"
              v-for="tag in dynamicTags"
              @click="clickTag(tag)"
              :disable-transitions="false">
            {{ tag }}
          </el-tag>
        </el-form-item>
        <el-form-item label="公式项" prop="itemList">
          <el-tag
              :key="tag"
              v-for="tag in form.itemList"
              closable
              size="medium"
              @click="clickTag(tag)"
              :disable-transitions="false"
              @close="handleClose(tag)">
            {{ tag }}
          </el-tag>
          <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+添加</el-button>
        </el-form-item>
        <el-form-item label="公式" prop="formula">
          <el-input v-model="form.formula" placeholder="请点击标签拼接公式" readonly clearable>
            <el-button slot="append" icon="el-icon-circle-close" @click="resetFormula">重置</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="结果" prop="result">
          <el-input v-model="form.result" placeholder="请输入结果"  clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="公式描述">
          <el-input v-model="form.intro" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {selectFormulaList, addFormula,delFormula} from '@/api/storeFormula.js'

export default {
  components: {},
  props: {},
  data() {
    return {
      queryParam: {
        name: '',
      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      dialogFormVisible: false,
      form: {
        id: '',
        name: '',
        intro: '',
        itemList: [],
        formula: '',
        result:''
      },
      dynamicTags: ['(', ')', '*', '/', '+', '-'],
      inputVisible: false,
      inputValue: '',
      title:'新增公式',
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        itemList: [
          {required: true, message: '请输入公式项', trigger: 'blur'}
        ],
        formula: [
          {required: true, message: '请输入公式', trigger: 'blur'}
        ],
        result: [
          {required: true, message: '请输入结果', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    resetForm(){
      this.form.id = ''
      this.form.name = ''
      this.form.intro = ''
      this.form.formula = ''
      this.form.itemList = []
    },
    edit(row){
      this.form = JSON.parse(JSON.stringify(row))
      this.title='编辑公式'
      this.dialogFormVisible = true
    },
    del(row){
      delFormula({id:row.id}).then(res=>{
        this.$message.success('删除成功')
        this.getList()
      })
    },
    resetFormula() {
      this.form.formula = ''
    },
    clickTag(tag) {
      this.form.formula = this.form.formula + tag
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.itemList.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    getCustomer() {
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddCode() {
      this.resetForm()
      this.dialogFormVisible = true
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      params = Object.assign(params, this.queryParam)
      selectFormulaList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },

    getTypeName() {

    },
    reset() {
      this.queryParam.name = ''
      this.getList()
    },
    save() {
      if (!this.form.itemList || this.form.itemList.length == 0) {
        this.$message.error('请添加公式项')
        return
      }
      if (!this.form.formula || this.form.formula.length == 0) {
        this.$message.error('请添加公式')
        return
      }
      addFormula(this.form).then(res => {
        this.$message.success('保存成功')
        this.dialogFormVisible = false
        this.getList()
      })
    }
  }

}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.pageBox {
  display: flex;
  justify-content: flex-end;
}
</style>
